import { BiteLogFatalError } from './bite_log_fatal_error.js';

export function name(event: BiteLogFatalError): string {
  switch (event) {
    case BiteLogFatalError.None:
      return 'DEVICE OK';

    case BiteLogFatalError.ReachabilityDown:
      return 'no-internet-connection';

    case BiteLogFatalError.ScannerDisconnected:
      return 'scanner-disconnected';
    case BiteLogFatalError.ScaleDisconnected:
      return 'scale-disconnected';
    case BiteLogFatalError.ScannerMissing:
      return 'scanner-missing';
    case BiteLogFatalError.ScaleMissing:
      return 'scale-missing';

    case BiteLogFatalError.KitchenPrinterMissing:
      return 'kitchen-printer-missing';
    case BiteLogFatalError.KitchenPrinterDisconnected:
      return 'kitchen-printer-disconnected';
    case BiteLogFatalError.KitchenPrinterNoPaper:
      return 'kitchen-printer-no-paper';
    case BiteLogFatalError.KitchenPrinterCoverOpen:
      return 'kitchen-printer-cover-open';
    case BiteLogFatalError.KitchenPrinterConsecutiveFailedJobs:
      return 'kitchen-printer-consecutive-failed-jobs';

    case BiteLogFatalError.ReceiptPrinterMissing:
      return 'receipt-printer-missing';
    case BiteLogFatalError.ReceiptPrinterDisconnected:
      return 'receipt-printer-disconnected';
    case BiteLogFatalError.ReceiptPrinterConsecutiveFailedJobs:
      return 'receipt-printer-consecutive-failed-jobs';
    case BiteLogFatalError.ReceiptPrinterNoPaper:
      return 'receipt-printer-no-paper';
    case BiteLogFatalError.ReceiptPrinterCoverOpen:
      return 'receipt-printer-cover-open';

    case BiteLogFatalError.PaymentTerminalUpdating:
      return 'payment-terminal-updating';
    case BiteLogFatalError.PaymentTerminalDisconnected:
      return 'payment-terminal-disconnected';
    case BiteLogFatalError.PaymentTerminalMissing:
      return 'payment-terminal-missing';
    case BiteLogFatalError.PeripheralJawsDisconnected:
      return 'peripheral-jaws-disconnected';
    case BiteLogFatalError.PeripheralKdsDisconnected:
      return 'peripheral-kds-disconnected';
    case BiteLogFatalError.PeripheralLrsTableTrackerDisconnected:
      return 'peripheral-lrs-table-tracker-disconnected';
    case BiteLogFatalError.PeripheralMsrDisconnected:
      return 'peripheral-msr-disconnected';

    case BiteLogFatalError.MenuDataMissing:
      return 'menu-data-missing';
    case BiteLogFatalError.UsersDataMissing:
      return 'users-data-missing';
    case BiteLogFatalError.ScriptMissing:
      return 'script-missing';
    case BiteLogFatalError.ImageMissing:
      return 'image-missing';
    case BiteLogFatalError.WebViewNotReady:
      return 'webview-not-ready';
    case BiteLogFatalError.Unstarted:
      return 'unstarted';

    case BiteLogFatalError.KioskError:
      return 'kiosk-error';
  }
}

export function stringFromEnum(event: BiteLogFatalError): string {
  switch (event) {
    case BiteLogFatalError.None:
      return 'none';
    case BiteLogFatalError.ReachabilityDown:
      return 'reachability-down';
    case BiteLogFatalError.KitchenPrinterMissing:
      return 'kitchen-printer-missing';
    case BiteLogFatalError.KitchenPrinterDisconnected:
      return 'kitchen-printer-disconnected';
    case BiteLogFatalError.KitchenPrinterNoPaper:
      return 'kitchen-printer-no-paper';
    case BiteLogFatalError.KitchenPrinterCoverOpen:
      return 'kitchen-printer-cover-open';
    case BiteLogFatalError.KitchenPrinterConsecutiveFailedJobs:
      return 'kitchen-printer-consecutive-failed-jobs';
    case BiteLogFatalError.ReceiptPrinterMissing:
      return 'receipt-printer-missing';
    case BiteLogFatalError.ReceiptPrinterDisconnected:
      return 'receipt-printer-disconnected';
    case BiteLogFatalError.ReceiptPrinterNoPaper:
      return 'receipt-printer-no-paper';
    case BiteLogFatalError.ReceiptPrinterCoverOpen:
      return 'receipt-printer-cover-open';
    case BiteLogFatalError.ReceiptPrinterConsecutiveFailedJobs:
      return 'receipt-printer-consecutive-failed-jobs';
    case BiteLogFatalError.PaymentTerminalMissing:
      return 'payment-terminal-missing';
    case BiteLogFatalError.PaymentTerminalDisconnected:
      return 'payment-terminal-disconnected';
    case BiteLogFatalError.PaymentTerminalUpdating:
      return 'payment-terminal-updating';
    case BiteLogFatalError.PeripheralJawsDisconnected:
      return 'peripheral-jaws-disconnected';
    case BiteLogFatalError.PeripheralKdsDisconnected:
      return 'peripheral-kds-disconnected';
    case BiteLogFatalError.PeripheralLrsTableTrackerDisconnected:
      return 'peripheral-lrs-table-tracker-disconnected';
    case BiteLogFatalError.PeripheralMsrDisconnected:
      return 'peripheral-msr-disconnected';
    case BiteLogFatalError.MenuDataMissing:
      return 'menu-data-missing';
    case BiteLogFatalError.UsersDataMissing:
      return 'user-data-missing';
    case BiteLogFatalError.ScriptMissing:
      return 'script-missing';
    case BiteLogFatalError.ImageMissing:
      return 'image-missing';
    case BiteLogFatalError.WebViewNotReady:
      return 'webview-not-ready';
    case BiteLogFatalError.Unstarted:
      return 'unstarted';
    case BiteLogFatalError.KioskError:
      return 'kiosk-error';
    case BiteLogFatalError.ScannerDisconnected:
      return 'scanner-disconnected';
    case BiteLogFatalError.ScaleDisconnected:
      return 'scale-disconnected';
    case BiteLogFatalError.ScannerMissing:
      return 'scanner-missing';
    case BiteLogFatalError.ScaleMissing:
      return 'scale-missing';
  }
}
